import {isNotNil} from 'ramda';

import {SeriesPatternRequestBody} from '@dms/api/core';

import {getApiDateString} from 'shared/web';

import {DocumentSeriesFormValues} from '../types/DocumentSeriesFormValues';
import {getRawStartingNumber} from './getRawStartingNumber';

export const transformPatternsToString = (
  patterns: DocumentSeriesFormValues['patterns']
): SeriesPatternRequestBody[] =>
  patterns?.map((pattern) => ({
    ...pattern,
    startingNumber: Number(getRawStartingNumber(pattern)),
    from: isNotNil(pattern.from) ? getApiDateString(pattern.from) : null,
  }));
